import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReplenishProducts from '../../components/blocks/ReplenishProducts';
import { updateCart } from '../../store/actions/cart';
import { setProductFiltersSearch } from '../../store/actions/productFilters';

import {
  setReplenishProductsOffset,
  setReplenishProductsCurrentFilter,
  setReplenishProductsSearch,
  setReplenishProductsOrderField,
  setReplenishProductsOrder,
  buyProduct,
  setReplenishProductsSupplierId,
  getReplenishProductsBrands,
} from '../../store/actions/replenishProducts';

function ReplenishProductsPermissionsContainer(props) {
  const { getReplenishBrands, count, perPage } = props;

  let [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    getReplenishBrands();
  }, [getReplenishBrands]);

  useEffect(() => {
    setPageCount(Math.ceil(count / perPage));
  }, [count, perPage]);

  return <ReplenishProducts {...props} pageCount={pageCount} />;
}

const mapStateToProps = (state) => {
  const { cart, role, replenishProducts, checked } = state;
  const { retailerId, user } = role;
  const { data, count, perPage, modalProduct, search, offset, brands, supplierId, isLoading, isLoadingProducts } =
    replenishProducts;
  const { filters, currentFilters, currentFilterSearches } = state.productFilters;
  const { retailerSuppliers } = state.role;

  const currentBrand = brands.find(({ value }) => value === supplierId);
  const validatedCreditCard = currentBrand ? currentBrand.validated_credit_card : false;

  const retailerSupplier = retailerSuppliers.find((retailerSupplier) => retailerSupplier.supplier.id === supplierId);

  let cartsData;
  let isAdmin;
  let marketingAssetsLink;
  let supplierName;

  if (user) {
    const { id: userId } = user;
    cartsData = cart.cartsData.find((cart) => cart.user_id === userId && cart.retailer_id === retailerId);

    const retailerPermission = user.retailers.find(({ id }) => id === retailerId);
    isAdmin = retailerPermission ? retailerPermission.administration_permission === 'write' : false;
  }

  if (retailerSupplier) {
    marketingAssetsLink = retailerSupplier.supplier.marketing_assets_link;
    supplierName = retailerSupplier.supplier.name;
  }

  return {
    data,
    count,
    perPage,
    checked,
    brands,
    modalProduct,
    isLoading,
    isLoadingProducts,
    offset,
    searchQuery: search,
    retailerId,
    supplierId,
    cartsData,
    validatedCreditCard,
    isAdmin,
    filters,
    currentFilters,
    currentFilterSearches,
    marketingAssetsLink,
    supplierName,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setSortOrder: (order) => dispatch(setReplenishProductsOrder(order)),
  setSortOrderField: (field) => dispatch(setReplenishProductsOrderField(field)),
  getReplenishBrands: () => dispatch(getReplenishProductsBrands()),
  productSearch: (search) => dispatch(setReplenishProductsSearch(search)),
  setPage: (offset) => dispatch(setReplenishProductsOffset(offset)),
  setFilter: (filter) => dispatch(setReplenishProductsCurrentFilter(filter)),
  setFilterSearch: (filter, search) => dispatch(setProductFiltersSearch(filter, search)),
  buyProduct: (model) => dispatch(buyProduct(model)),
  setSupplierId: (id) => dispatch(setReplenishProductsSupplierId(id)),
  updateCart: (data) => dispatch(updateCart(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReplenishProductsPermissionsContainer);

ReplenishProductsPermissionsContainer.defaultProps = {
  checked: {},
  isAdmin: false,
};

ReplenishProductsPermissionsContainer.propTypes = {
  filters: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  count: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  setSortOrderField: PropTypes.func.isRequired,
  productSearch: PropTypes.func.isRequired,
  checked: PropTypes.object,
  setPage: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,
  getReplenishBrands: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  modalProduct: PropTypes.object,
  cartsData: PropTypes.object,
  isAdmin: PropTypes.bool.isRequired,
};
